module.exports = __webpack_public_path__ + "static/media/bg-2.a1adb185.jpg";